import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  ScheduleTitle: {
    textAlign: 'left',
    fontSize: '15px',
    fontWeight: '500 !important',
    marginTop: '17px !important',
    marginLeft: '10px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '13px !important',
    },
  },
  ScheduleCard: {
    boxShadow: 'none !important',
    padding: '10px !important',
    borderRadius: '10px !important',
  },
  ScheduleCard1: {
    boxShadow: 'none !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    height: '72vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '65.5vh',
    },
  },
  postJobBtns: {
    width: '230px',
    borderRadius: '8px !important',
    padding: '7px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      padding: '2px !important',
      width: '170px',
    },
  },
}));
